import { render, staticRenderFns } from "./SummaryReports.vue?vue&type=template&id=f668d8da&"
import script from "./SummaryReports.vue?vue&type=script&lang=js&"
export * from "./SummaryReports.vue?vue&type=script&lang=js&"
import style0 from "./SummaryReports.vue?vue&type=style&index=0&id=f668d8da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports